import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

export function initLogout() {
  const btn = document.getElementById('logout-btn');
  if (!btn) return;

  btn.addEventListener('click', async () => {
    const confirmed = await confirmAction({
      title: 'Abmelden',
      message: 'Möchten Sie sich wirklich abmelden?',
      okText: 'Abmelden'
    });
    if (!confirmed) return;

    showLoading('Sie werden abgemeldet …');

    try {
      await http.post('/auth/logout');
      window.location.href = withFlash('/login', 'abgemeldet');
    } catch (err) {
      hideLoading();
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
